module.exports = __webpack_public_path__ + "3cc5ca88f3d815d0427366394fa42184.png";